// utils/statusMapper.js

export const getVendorStatusFromBuyerStatus = (buyerStatus = "") => {
  const statusMap = {
    draft: null, // Hide RFQ for vendors
    submitted: "OPEN",
    reauction_submitted: "RE AUCTION OPEN",
    received_quotes: "QUOTE SUBMITTED", // Default for vendors until they submit
    evaluated: "UNDER REVIEW",
    negotiation: "NEGOTIATION REQUESTED",
    accepted: "QUOTE FINALIZED",
    rejected: "REJECTED",
    auctioned: "AUCTION INVITED",
    requested_hod_approval: "Under Review",
    hod_approved: "APPROVED",
  };

  const normalized = buyerStatus?.toLowerCase();
  return statusMap[normalized] || "PENDING";
};
